import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Products', href: '#products' },
    { name: 'About', href: '#about' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Reviews', href: '#reviews' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <>
      {/* Top Bar - hidden on mobile */}
      <div className="hidden md:block bg-black border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-10">
            <div className="flex items-center gap-4 md:gap-8 text-xs text-gray-400">
              <a href="tel:+381642428074" className="flex items-center gap-2 hover:text-white transition-colors">
                <i className="ri-phone-line"></i>
                <span>+381 64 242 8074</span>
              </a>
              <div className="hidden md:flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@eaglecarbon.com</span>
              </div>
            </div>
            <div className="flex items-center gap-4 md:gap-6 text-xs text-gray-400">
              <div className="hidden md:flex items-center gap-2">
                <i className="ri-shield-check-line text-white"></i>
                <span className="text-white">5-Year Warranty</span>
              </div>
              <div className="hidden md:flex items-center gap-2">
                <i className="ri-global-line"></i>
                <span>Worldwide Shipping</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className={`fixed top-0 md:top-10 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileMenuOpen ? 'bg-black/98 backdrop-blur-xl border-b border-white/10 shadow-2xl' : 'bg-transparent'
      }`}>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <a href="#home" className="flex items-center gap-2 md:gap-3 group cursor-pointer">
              <div className="w-9 h-9 md:w-11 md:h-11 bg-white flex items-center justify-center relative overflow-hidden">
                <i className="ri-bird-fill text-black text-lg md:text-xl relative z-10"></i>
              </div>
              <div>
                <div className="text-white text-base md:text-xl font-bold tracking-tight leading-none">EagleCarbon</div>
                <div className="text-gray-500 text-[8px] md:text-[9px] uppercase tracking-[2px] font-medium">Motorsport</div>
              </div>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-10">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="group relative text-gray-300 text-sm font-medium tracking-wide hover:text-white transition-colors cursor-pointer"
                >
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-white group-hover:w-full transition-all duration-300"></span>
                </a>
              ))}
            </div>

            {/* CTA Button - desktop */}
            <div className="hidden lg:block">
              <button className="bg-white px-7 py-3 text-black text-sm font-semibold tracking-wide hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
                GET QUOTE
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/98 backdrop-blur-xl border-t border-white/10">
            <div className="max-w-[1400px] mx-auto px-4 py-6">
              <div className="flex flex-col gap-1">
                {navLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className="text-gray-300 text-base font-medium hover:text-white transition-colors py-3 border-b border-white/5 cursor-pointer"
                  >
                    {link.name}
                  </a>
                ))}
                <button className="bg-white px-7 py-3 text-black text-sm font-semibold tracking-wide hover:bg-gray-200 transition-all mt-4 whitespace-nowrap cursor-pointer w-full">
                  GET QUOTE
                </button>
                {/* Mobile contact info */}
                <div className="flex flex-col gap-2 mt-4 pt-4 border-t border-white/10">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-phone-line"></i>
                    <span>+381 64 242 8074</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-mail-line"></i>
                    <span>info@eaglecarbon.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
